import React from 'react';
import '../App.css';

/**
 * スケルトンローダーコンポーネント
 *
 * variant:
 *   - "detail"   : 詳細ページ用（ヘッダー + タブ + フォーム行）
 *   - "list"     : 一覧ページ用（カード型のリスト）
 *   - "text"     : テキストブロック用（単純な行の繰り返し）
 *
 * rows: 表示する行数（デフォルト: 4）
 *
 * CSS定義: App.css の「スケルトンローダー」セクション
 * ※ index.html にもプリロード用の同等スタイルあり（_shimmer）
 */
function SkeletonLoader({ variant = 'detail', rows = 4 }) {
  if (variant === 'detail') {
    return (
      <div className="skeleton-container skeleton-fade-in" role="status" aria-label="読み込み中">
        {/* ヘッダー部分 */}
        <div className="skeleton-header">
          <div className="skeleton-line skeleton-title" />
          <div className="skeleton-line skeleton-subtitle" />
        </div>

        {/* タブバー */}
        <div className="skeleton-tabs">
          <div className="skeleton-tab" />
          <div className="skeleton-tab" />
          <div className="skeleton-tab" />
        </div>

        {/* フォーム行 */}
        <div className="skeleton-body">
          {Array.from({ length: rows }).map((_, i) => (
            <div className="skeleton-row" key={i}>
              <div className="skeleton-line skeleton-label" />
              <div className="skeleton-line skeleton-value" style={{ width: `${65 + (i * 7) % 30}%` }} />
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (variant === 'list') {
    return (
      <div className="skeleton-container skeleton-fade-in" role="status" aria-label="読み込み中">
        {Array.from({ length: rows }).map((_, i) => (
          <div className="skeleton-card" key={i}>
            <div className="skeleton-line skeleton-card-title" />
            <div className="skeleton-line skeleton-card-desc" />
            <div className="skeleton-line skeleton-card-meta" />
          </div>
        ))}
      </div>
    );
  }

  // variant === 'text'
  return (
    <div className="skeleton-container skeleton-fade-in" role="status" aria-label="読み込み中">
      {Array.from({ length: rows }).map((_, i) => (
        <div className="skeleton-line skeleton-text-line" key={i} style={{ width: `${70 + (i * 11) % 25}%` }} />
      ))}
    </div>
  );
}

export default SkeletonLoader;
